import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AccessLevel, CampaignTypeFilter } from '@dev/ee-api/ee-api-models';

import { palette, TertiaryButton } from '@dev/ee-components';
import React from 'react';
import { getAccountAccessLevel } from '@/store/account/actions';
import { DeleteCampaigns, getCampaignsStore } from '@/store/campaigns/actions';
import { TableHeaderProps } from '../../DraftsList/DraftsListInterface';

export const useTableHeaders = (): TableHeaderProps[] => {
    const { t } = useTranslation();
    const accountAl = useSelector(getAccountAccessLevel);
    const campaigns = useSelector(getCampaignsStore);

    const screenCampaignType = [CampaignTypeFilter.Draft];

    const dispatch = useDispatch();

    const headers = [
        {
            id: 'preview',
            isDisablePadding: true,
            isDisableSort: true,
            isNumeric: false,
            label: '',
        },
        {
            id: 'campaignName',
            label: t('name'),
            isDisableSort: true,
            isNumeric: false,
            isDisablePadding: true,
        },
        {
            id: 'status',
            label: t('status'),
            isDisableSort: true,
            isNumeric: false,
        },
        {
            id: 'icon',
            isDisableSort: true,
            isNumeric: false,
            isDisablePadding: true,
            headerAlign: 'right',
            columnAlign: 'right',
        },
    ];

    const checkedHeaders = [
        {
            id: 'preview',
            isDisablePadding: true,
            isDisableSort: true,
            isNumeric: false,
            label: t('campaigns'),
        },
        {
            id: 'campaignName',
            isDisableSort: true,
            isNumeric: false,
            isDisablePadding: true,
            label: '',
        },
        {
            id: 'status',
            isDisableSort: true,
            isDisablePadding: true,
            isNumeric: false,
            label: '',
            headerAlign: 'right',
            filterIcon: accountAl?.includes(AccessLevel.ModifyCampaigns) && (
                <TertiaryButton
                    style={{ margin: 0, color: palette.red[6] }}
                    text={t('delete')}
                    onClick={() => {
                        dispatch(DeleteCampaigns(campaigns.checkedCampaigns, screenCampaignType));
                    }}
                />
            ),
        },
    ];

    return (campaigns.checkedCampaigns.length || 0) > 0 ? checkedHeaders : headers;
};
